import { ImgCategoryType, ImgModeType, StretchOptionType } from '@meitu/saas-editor-core/es/version-types';
import { ImagePanelFeatureType } from '@/types';

export enum IImgPanelType {
    // 蒙版
    MASK = 'MASK',
    // 滤镜
    FILTER = 'FILTER',
    // 特效
    EFFECT = 'EFFECT',
    // 调色
    ADJUST = 'ADJUST',
    // 消除笔
    ELIMINATE_PEN = 'ELIMINATE_PEN',
    // 裁剪
    CROP = 'CROP',
}

// 卡片功能参数
export interface ICardMenuProps {
    featureType: ImagePanelFeatureType;
    curType: ImagePanelFeatureType | '';
    setCurType: Function;
    trackFunc?: string;
    // 打开关闭切换
    onToggle?: (feature: ImagePanelFeatureType, isOpen: boolean, e: React.MouseEvent) => void;
    // 重置功能
    onReset?: (feature: ImagePanelFeatureType) => void;
    // 滑块调整
    onSlider?: (feature: ImagePanelFeatureType, type: string, click_type?: number, hideTick?: boolean) => void;
    // 选择颜色
    onSelect?: (feature: ImagePanelFeatureType, index: number, type?: string) => void;
    // tab切换
    onTab?: (feature: ImagePanelFeatureType, type: string) => void;
    // 形状笔属性变更
    onAttrChange?: (feature: ImagePanelFeatureType, attr: string, click_type: number) => void;
}

export interface IOptionProp {
    label: string;
    value: number;
    desc?: string;
    disabled?: boolean;
}

export const tagBgImgConfig: IOptionProp = {
    label: '背景图',
    value: ImgCategoryType.bgImg,
};

export const imgModeOptions: IOptionProp[] = [
    {
        label: '无功能',
        value: ImgModeType.none,
    },
    {
        label: '图片容器',
        value: ImgModeType.imgContainer,
    },
    {
        label: '自动抠图',
        value: ImgModeType.matting,
    },
    {
        label: '自动抠头',
        value: ImgModeType.mattingHead,
    },
];
export const stretchOptions: IOptionProp[] = [
    {
        label: '禁用拉伸',
        value: StretchOptionType.none,
    },
    {
        label: '变形拉伸',
        value: StretchOptionType.fill,
    },
    {
        label: '智能拉伸',
        value: StretchOptionType.cover,
    },
];

export const shineOptions: IOptionProp[] = [
    {
        label: '无高亮闪烁',
        value: 0,
    },
    {
        label: '高亮闪烁',
        value: 1,
    },
];

export const hintOptions: IOptionProp[] = [
    {
        label: '是',
        value: 1,
        desc: '展示替换按钮',
    },
    {
        label: '否',
        value: 0,
        desc: '不展示替换按钮',
    },
];
